import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toFixed'
})
export class ToFixedPipe implements PipeTransform {
  transform(value: any, digits: number = 3): any {
    if (value === null || value === undefined || isNaN(value)) return '-';
    return Number(value).toFixed(digits);
  }
}
